import { render, staticRenderFns } from "./UpdateInProgress.vue?vue&type=template&id=6b2bb20e&scoped=true&lang=pug&"
import script from "./UpdateInProgress.vue?vue&type=script&lang=js&"
export * from "./UpdateInProgress.vue?vue&type=script&lang=js&"
import style0 from "./UpdateInProgress.vue?vue&type=style&index=0&id=6b2bb20e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2bb20e",
  null
  
)

export default component.exports